//
//
//
//
//
//

import { topNavSearchClear } from '@tidal/styles-icons';

export default {
    computed: {
        icons() {
            return { topNavSearchClear };
        },
    },
};
